import * as components from '@/components'
import Moment from 'moment' 
import axios from 'axios'

const CustomComponents = {
  install: function (Vue, options) {
    if (components) {
      Object.keys(components).forEach(key => {
        const c = components[key]
        Vue.component(c.name, c)
      })
    }

    Moment.locale('pt-br')
    Vue.prototype.$moment = Moment

    Vue.prototype.$permission = (apps) => {
      let retorno = false;

      for (let ap of apps) {
        if (ap == 'public'){
          retorno = true;
          break;
        }

        for (const resource in Vue.prototype.$keycloak.resourceAccess) {
          if (resource == ap){
            retorno = true;
          }
        }
      }

      return retorno;
    }

    Vue.prototype.$axios = axios
    Vue.prototype.$api = (nome) => {
      const instance = Vue.prototype.$axios.create({
        baseURL: process.env['VUE_APP_API_URL_'+nome.toUpperCase()]
      })

      // Configura o AXIOS
      instance.interceptors.request.use(config => {
        config.headers.Authorization = `Bearer ${Vue.prototype.$keycloak.token}`
        return config
      }, error => {
        return Promise.reject(error)
      })

      return instance
    }
  }
}

export default CustomComponents